import { post,get } from "../network/index.js";
// 获取授权信息
const getAuth = (data) => {
  return get("/mercWebi/workWx/getAuth", data);
};
// 服务商回调通知
const providerNotify = (data) => {
  return post("/mercWebi/workWx/provider/notify", data);
};
// 设置商家企业ID
const setCorpId = (data) => {
  return post("/mercWebi/workWx/setCorpId", data);
};
// 代开发应用回调通知{mercCode}
const suiteNotify = (data) => {
  return get("/mercWebi/workWx/suite/notify", data);
};
// 同步部门员工
const syncQyDeptUser = (data) => {
  return post("/mercWebi/workWx/syncQyDeptUser", data);
};
// 同步员工客户及社群信息
const syncQyExternal = (data) => {
  return post("/mercWebi/workWx/syncQyExternal", data);
};
// 同步社群信息
const syncQyGroup = (data) => {
  return post("/mercWebi/workWx/syncQyGroup", data);
};
//修改授权信息
const updateAuth = data => {
  return post('/mercWebi/workWx/updateAuth', data)
}
// 查询社群列表
const queryGroupchatList = (data) => {
  return post("/mercWebi/workWxUser/queryGroupchatList", data);
};
// 查询社群详情
const groupchatDetail = (data) => {
  return post("/mercWebi/workWxUser/groupchatDetail", data);
};
// 查询社群详情-送达
const querySendExtUserDetail = data => {
  return post('/mercWebi/workWxUser/querySendExtUserDetail', data)
}
// 查询社群成员列表
const queryGroupMemberList = (data) => {
  return post("/mercWebi/workWxUser/queryGroupMemberList", data);
};
// 查询企微员工客户列表
const queryQyExtUserList = (data) => {
  return post("/mercWebi/workWxUser/queryQyExtUserList", data);
};
// 查询企微员工列表
const queryQyUserList = (data) => {
  return post("/mercWebi/workWxUser/queryQyUserList", data);
};
// 查询企微员工列表-带部门
const queryGetQyDeptUser= data => {
  return post('/mercWebi/workWxUser/getQyDeptUser', data)
}
// 查询企微员工详情
const qyUserDetail = (data) => {
  return post("/mercWebi/workWxUser/qyUserDetail", data);
};
// 新建群发
const createMsgTemplate = (data) => {
  return post("/mercWebi/workWxMsg/createMsgTemplate", data);
};
//群发列表
const msgTemplateList = (data) => {
  return post('/mercWebi/workWxMsgTemplate/queryTemplatePage', data)
};
//群发详情
const queryTemplateDetail = data => {
  return post('/mercWebi/workWxMsgTemplate/queryTemplateDetail', data)
}
//提醒发送
const remindGroupMsgSend = data => {
  return post('/mercWebi/workWxMsg/remindGroupMsgSend', data)
}
//刷新状态
const getSendResult = data => {
  return post('/mercWebi/workWxMsg/getSendResult', data)
}
//群发删除
const delTemplateTask = data => {
  return post('/mercWebi/workWxMsgTemplate/delTemplateTask', data)
}
// 上传临时素材
const mediaUpload = (data) => {
  return post("/mercWebi/workWxSource/mediaUpload", data);
};
// 临时素材列表
const sourceMaterialList = (data) => {
  return post("/mercWebi/workWxSource/pageQySource", data);
};
// 新增临时素材
const sourceMaterialAdd = (data) => {
  return post("/mercWebi/workWxSource/addSource", data);
};
// 修改素材信息
const sourceMaterialUpdate = (data) => {
  return post("/mercWebi/workWxSource/updateSource", data);
};
// 删除素材信息
const sourceMaterialDelete = (data) => {
  return post("/mercWebi/workWxSource/deleteSource", data);
};

export default {
  getAuth,
  providerNotify,
  setCorpId,
  suiteNotify,
  syncQyDeptUser,
  syncQyExternal,
  syncQyGroup,
  queryGroupchatList,
  groupchatDetail,
  querySendExtUserDetail,
  queryGroupMemberList,
  queryQyExtUserList,
  queryQyUserList,
  queryGetQyDeptUser,
  qyUserDetail,
  createMsgTemplate,
  msgTemplateList,
  queryTemplateDetail,
  remindGroupMsgSend,
  getSendResult,
  delTemplateTask,
  mediaUpload,
  sourceMaterialList,
  sourceMaterialUpdate,
  sourceMaterialDelete,
  sourceMaterialAdd,
  updateAuth
}
